// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"221":"component---src-pages-index-copy-tsx","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"221":"44509d84d541e9478839","245":"219ebe0a8035c9f2bab0","453":"8e83aabdcb9f17593709","739":"ec06601ea9c333679326","793":"7a1dcb26ee126fc04590"}[chunkId] + ".js";
};